import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Scale, ShieldCheck, Store, Megaphone } from "lucide-react";
import { canAccess } from "@/pages/Login";

const ITEMS = [
  { key: "user", label: "User", to: "/dashboard", icon: LayoutDashboard },
  { key: "attorney", label: "Marketplace", to: "/marketplace", icon: Store },
  { key: "attorney", label: "Referrals", to: "/attorney", icon: Scale, alt: true },
  { key: "affiliate", label: "Affiliate", to: "/affiliate", icon: Megaphone },
  { key: "admin", label: "Admin", to: "/admin", icon: ShieldCheck },
];

// Lets multi-role accounts jump between the portals they have access to.
export default function PortalSwitcher() {
  const { user } = useAuth();
  const location = useLocation();
  const available = ITEMS.filter((i) => canAccess(user, i.key));
  if (available.length <= 1) return null;

  return (
    <div className="flex items-center gap-1 bg-slate-100 rounded-full p-1" data-testid="portal-switcher">
      {available.map(({ label, to, icon: Icon }) => {
        const on = location.pathname === to || location.pathname.startsWith(to + "/");
        return (
          <Link key={to} to={to} data-testid={`switch-${label.toLowerCase()}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${on ? "bg-white text-navy shadow-sm" : "text-slate-500 hover:text-navy"}`}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </Link>
        );
      })}
    </div>
  );
}
